import { FC } from 'react';
import { AlertWrapper, UpgradeAlert } from './Wrapper';

export type UpgradeBlockAlertProps = {
  errors?: string[];
  success?: string[];
};

const UpgradeBlockAlert: FC<UpgradeBlockAlertProps> = ({ errors, success }) => {
  return (
    <AlertWrapper>
      {errors?.map(message => (
        <UpgradeAlert variant="danger" position="center">
          {message}
        </UpgradeAlert>
      ))}

      {success?.map(message => (
        <UpgradeAlert variant="success" position="center">
          {message}
        </UpgradeAlert>
      ))}
    </AlertWrapper>
  );
};

export default UpgradeBlockAlert;
